 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-009dff95":"a5bfb59d","chunk-09b45cf0":"d9eb7640","chunk-09d6dff3":"00478832","chunk-0adb630a":"904067e3","chunk-109e4a0e":"fbad6243","chunk-125d9736":"26285aea","chunk-17a76731":"f1a72103","chunk-18743bef":"93bc79f8","chunk-1a324f0c":"b5813408","chunk-1b247cbd":"f14f600e","chunk-1bc8f52c":"e271f4f4","chunk-20452b85":"6caf08c9","chunk-208c2446":"da0ed90a","chunk-20f416cc":"5b4e16d7","chunk-22e8e15d":"87674dae","chunk-2349b137":"d9c027c6","chunk-24027364":"485b16db","chunk-256ce7e6":"2dbe6ed4","chunk-26c5141a":"44c6c8aa","chunk-28466fc8":"d82b4346","chunk-2d0b345c":"042db2cd","chunk-2d0bce05":"67db3087","chunk-2d0c77ad":"1341a561","chunk-2d0c8f6d":"89b47425","chunk-2d0c91d2":"9312964d","chunk-2d0cb6e8":"798b7344","chunk-2d0cbb33":"c969a6bf","chunk-2d0d0818":"bb5582a7","chunk-2d0da2ea":"b6e324bd","chunk-2d0da6a8":"99073112","chunk-2d0dace4":"0bdda766","chunk-2d0e95df":"c5d8b41b","chunk-2d210c28":"1688585c","chunk-2d212fd8":"bd8b504c","chunk-2d2253ae":"f16a1b6b","chunk-2ecfd031":"6ca71e7c","chunk-2b02de32":"42709182","chunk-3b806aa1":"60a4f614","chunk-303254b2":"cc7d7d00","chunk-30f27cba":"929fe6ca","chunk-3338c945":"6feba1a4","chunk-347ebcac":"a7bb0d6f","chunk-354b2aa8":"64a236d6","chunk-35a579a2":"33dab2f1","chunk-3a29d905":"e8e85838","chunk-3b7d8115":"721613a7","chunk-3d675996":"cdb7d5f9","chunk-3dbd8674":"84e0dfe2","chunk-42758afb":"0d186857","chunk-43c78365":"cbf51ccf","chunk-00357acc":"f3bdeb4b","chunk-17d2ea76":"7032d3ee","chunk-31e3aaf3":"c1bf5ff6","chunk-3635a07f":"2926489b","chunk-4b330e93":"88499090","chunk-4e2546e6":"c6a6267d","chunk-540eb546":"94235b99","chunk-59d91b22":"7bdfba72","chunk-844aa964":"dc1cac14","chunk-8f099ab8":"f8b0d941","chunk-9fe4383e":"59b4c467","chunk-b92141c0":"c683a823","chunk-dd2b1d46":"d95eb986","chunk-44a3da96":"ee0e20f6","chunk-45176c89":"d1160776","chunk-456a9c73":"860c49cd","chunk-49117393":"23427b8c","chunk-4a8510ab":"fbc25bfb","chunk-4b380372":"1a6dda41","chunk-4d17f324":"bc729242","chunk-4eb4751d":"50e35a42","chunk-500f1185":"a2897375","chunk-51bf7232":"d2df5447","chunk-545326c0":"e43b2e4d","chunk-56cc7a73":"3103a644","chunk-56dec1a4":"5e85ca92","chunk-5a84305a":"1fd9c8bf","chunk-5dc3278d":"ab4a4dae","chunk-5fd9ef88":"a4fc5d92","chunk-609e28f6":"336d2e90","chunk-646bac48":"b62c9349","chunk-6700755d":"651a9d91","chunk-67147130":"bcbc5aa7","chunk-67db813b":"7a480eaf","chunk-6ac44d3d":"9fbbb82b","chunk-6cd8d239":"696e1e9d","chunk-4dc0318a":"6423f2a4","chunk-c154174a":"01755a24","chunk-6d7092e8":"7b9da3f3","chunk-6e6dcf96":"b3668a8e","chunk-6f384fdc":"0101cb31","chunk-6f60227b":"bf88446b","chunk-70b10f04":"9857eb17","chunk-70e35ebc":"467284d1","chunk-73e9d5f2":"6747e4db","chunk-744c292d":"87b927e3","chunk-7459c046":"15b887e4","chunk-7727bc82":"d633874c","chunk-7734d3ad":"d9c6d5f0","chunk-7b5158a7":"34fdd446","chunk-7e16cd9d":"81ca8384","chunk-7ed8b0ce":"142bad12","chunk-7f66c91b":"d8ed246b","chunk-7f706172":"102c8b54","chunk-8039543e":"660cfafd","chunk-982b6af2":"e035676c","chunk-99bcc778":"ff5e0558","chunk-9ac5abb0":"0fca5e09","chunk-9eba3760":"d4ed1e6a","chunk-a39ff88a":"610fe02c","chunk-a48a8aa2":"32763475","chunk-ac7c3ac8":"fbc3186a","chunk-adc2bb66":"f675ab09","chunk-b69214c2":"9190e292","chunk-b81bcb8a":"2f3e9eb3","chunk-b8bd5ffe":"6b88558c","chunk-bb9055bc":"4832fa82","chunk-c093b1d2":"74fef1e6","chunk-c6b29aa4":"fa645c26","chunk-cf78b932":"f67c65a1","chunk-d2175d8a":"5978d73a","chunk-e1a6d904":"b8f4c539","chunk-ed77b080":"633510bb","chunk-f88a8512":"03df7ef3","chunk-faf9c3f6":"213b6619","fail":"192e6a54","lang-en-US":"227df357","lang-en-US-setting":"c7ad6c0a","lang-vi":"6a9e77d5","lang-vi-setting":"1cf90170","user":"3beae04b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-17a76731":1,"chunk-18743bef":1,"chunk-24027364":1,"chunk-30f27cba":1,"chunk-354b2aa8":1,"chunk-45176c89":1,"chunk-456a9c73":1,"chunk-56cc7a73":1,"chunk-56dec1a4":1,"chunk-609e28f6":1,"chunk-6700755d":1,"chunk-6cd8d239":1,"chunk-4dc0318a":1,"chunk-c154174a":1,"chunk-744c292d":1,"chunk-7459c046":1,"chunk-7ed8b0ce":1,"chunk-7f66c91b":1,"chunk-7f706172":1,"chunk-8039543e":1,"chunk-a39ff88a":1,"chunk-b8bd5ffe":1,"chunk-d2175d8a":1,"chunk-f88a8512":1,"chunk-faf9c3f6":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-009dff95":"31d6cfe0","chunk-09b45cf0":"31d6cfe0","chunk-09d6dff3":"31d6cfe0","chunk-0adb630a":"31d6cfe0","chunk-109e4a0e":"31d6cfe0","chunk-125d9736":"31d6cfe0","chunk-17a76731":"f39e5dda","chunk-18743bef":"4f477acb","chunk-1a324f0c":"31d6cfe0","chunk-1b247cbd":"31d6cfe0","chunk-1bc8f52c":"31d6cfe0","chunk-20452b85":"31d6cfe0","chunk-208c2446":"31d6cfe0","chunk-20f416cc":"31d6cfe0","chunk-22e8e15d":"31d6cfe0","chunk-2349b137":"31d6cfe0","chunk-24027364":"f10d60c8","chunk-256ce7e6":"31d6cfe0","chunk-26c5141a":"31d6cfe0","chunk-28466fc8":"31d6cfe0","chunk-2d0b345c":"31d6cfe0","chunk-2d0bce05":"31d6cfe0","chunk-2d0c77ad":"31d6cfe0","chunk-2d0c8f6d":"31d6cfe0","chunk-2d0c91d2":"31d6cfe0","chunk-2d0cb6e8":"31d6cfe0","chunk-2d0cbb33":"31d6cfe0","chunk-2d0d0818":"31d6cfe0","chunk-2d0da2ea":"31d6cfe0","chunk-2d0da6a8":"31d6cfe0","chunk-2d0dace4":"31d6cfe0","chunk-2d0e95df":"31d6cfe0","chunk-2d210c28":"31d6cfe0","chunk-2d212fd8":"31d6cfe0","chunk-2d2253ae":"31d6cfe0","chunk-2ecfd031":"31d6cfe0","chunk-2b02de32":"31d6cfe0","chunk-3b806aa1":"31d6cfe0","chunk-303254b2":"31d6cfe0","chunk-30f27cba":"3ed69e3d","chunk-3338c945":"31d6cfe0","chunk-347ebcac":"31d6cfe0","chunk-354b2aa8":"1b938cc5","chunk-35a579a2":"31d6cfe0","chunk-3a29d905":"31d6cfe0","chunk-3b7d8115":"31d6cfe0","chunk-3d675996":"31d6cfe0","chunk-3dbd8674":"31d6cfe0","chunk-42758afb":"31d6cfe0","chunk-43c78365":"31d6cfe0","chunk-00357acc":"31d6cfe0","chunk-17d2ea76":"31d6cfe0","chunk-31e3aaf3":"31d6cfe0","chunk-3635a07f":"31d6cfe0","chunk-4b330e93":"31d6cfe0","chunk-4e2546e6":"31d6cfe0","chunk-540eb546":"31d6cfe0","chunk-59d91b22":"31d6cfe0","chunk-844aa964":"31d6cfe0","chunk-8f099ab8":"31d6cfe0","chunk-9fe4383e":"31d6cfe0","chunk-b92141c0":"31d6cfe0","chunk-dd2b1d46":"31d6cfe0","chunk-44a3da96":"31d6cfe0","chunk-45176c89":"dbdd5640","chunk-456a9c73":"5d51d3b8","chunk-49117393":"31d6cfe0","chunk-4a8510ab":"31d6cfe0","chunk-4b380372":"31d6cfe0","chunk-4d17f324":"31d6cfe0","chunk-4eb4751d":"31d6cfe0","chunk-500f1185":"31d6cfe0","chunk-51bf7232":"31d6cfe0","chunk-545326c0":"31d6cfe0","chunk-56cc7a73":"817f0b53","chunk-56dec1a4":"8a41c503","chunk-5a84305a":"31d6cfe0","chunk-5dc3278d":"31d6cfe0","chunk-5fd9ef88":"31d6cfe0","chunk-609e28f6":"4e3f5168","chunk-646bac48":"31d6cfe0","chunk-6700755d":"826d82f5","chunk-67147130":"31d6cfe0","chunk-67db813b":"31d6cfe0","chunk-6ac44d3d":"31d6cfe0","chunk-6cd8d239":"5748a23b","chunk-4dc0318a":"4aa6b438","chunk-c154174a":"e3a93821","chunk-6d7092e8":"31d6cfe0","chunk-6e6dcf96":"31d6cfe0","chunk-6f384fdc":"31d6cfe0","chunk-6f60227b":"31d6cfe0","chunk-70b10f04":"31d6cfe0","chunk-70e35ebc":"31d6cfe0","chunk-73e9d5f2":"31d6cfe0","chunk-744c292d":"3aac4123","chunk-7459c046":"3426b597","chunk-7727bc82":"31d6cfe0","chunk-7734d3ad":"31d6cfe0","chunk-7b5158a7":"31d6cfe0","chunk-7e16cd9d":"31d6cfe0","chunk-7ed8b0ce":"8a41c503","chunk-7f66c91b":"66183a72","chunk-7f706172":"11711f41","chunk-8039543e":"a60f24a6","chunk-982b6af2":"31d6cfe0","chunk-99bcc778":"31d6cfe0","chunk-9ac5abb0":"31d6cfe0","chunk-9eba3760":"31d6cfe0","chunk-a39ff88a":"f336c531","chunk-a48a8aa2":"31d6cfe0","chunk-ac7c3ac8":"31d6cfe0","chunk-adc2bb66":"31d6cfe0","chunk-b69214c2":"31d6cfe0","chunk-b81bcb8a":"31d6cfe0","chunk-b8bd5ffe":"3ed69e3d","chunk-bb9055bc":"31d6cfe0","chunk-c093b1d2":"31d6cfe0","chunk-c6b29aa4":"31d6cfe0","chunk-cf78b932":"31d6cfe0","chunk-d2175d8a":"9a85fade","chunk-e1a6d904":"31d6cfe0","chunk-ed77b080":"31d6cfe0","chunk-f88a8512":"707cb235","chunk-faf9c3f6":"36527024","fail":"31d6cfe0","lang-en-US":"31d6cfe0","lang-en-US-setting":"31d6cfe0","lang-vi":"31d6cfe0","lang-vi-setting":"31d6cfe0","user":"74c2f2b7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
